export enum EnumHospitalType {
  GOVERNMENT = "government",
  NON_GOVERNMENT = "non_government",
}
